import { Paper } from "@mui/material";
import React from "react";

function EmailTemplate({ data }: { data?: { img?: string } | null }) {
  if (!data) return null;

  return (
    <Paper className="text-center bg-light my-2" elevation={0}>
      <img src={data?.img} className="img-fluid template-img mx-auto" />
    </Paper>
  );
}

export default EmailTemplate;
